import type {RouteLocationNormalized} from 'vue-router';
import {defineNuxtRouteMiddleware, navigateTo} from '#imports';
import {sanitizeSingleStringParam} from '~/utils/query-param-sanitizer';

export default defineNuxtRouteMiddleware((to: RouteLocationNormalized) => {
    const query = to.query.q;

    if (!query || sanitizeSingleStringParam(query)?.trim() === '') {
        return navigateTo('/', {external: true});
    }
});
